export default "__VITE_ASSET__VYEIBAUQ__"